import { render } from "./Form3Ver2.vue?vue&type=template&id=cc79c44c&scoped=true"
import script from "./Form3Ver2.vue?vue&type=script&lang=js"
export * from "./Form3Ver2.vue?vue&type=script&lang=js"

import "./Form3Ver2.vue?vue&type=style&index=0&id=cc79c44c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc79c44c"]])

export default __exports__